import { AlertColor, Box } from '@mui/material';

import { convertSecondsToTimeFormat } from '../../../../../constants/helpers/dates';

import { Status } from './interfaces';

export const getBlockedInfo = (penaltyTime: number) => (
  <Box>
    <Box style={{ marginBottom: '8px' }}>OTP verification failed. Account temporarily blocked.</Box>
    <Box>
      As a result of repeatedly entering the OTP code incorrectly, your account has been temporarily blocked for
      security reasons.
    </Box>
    <Box mt={1}>
      You will be able to try again in: <b>{convertSecondsToTimeFormat(penaltyTime)}</b>
    </Box>
  </Box>
);

export const getEnabledInfo = () => (
  <Box>
    <Box style={{ marginBottom: '8px' }}>Access to the account has been restored</Box>
    An access to your account has been restored. You can start the client profile create process again. Click Proceed to
    create a new client profile to continue.
  </Box>
);

export const statusToSeverity = (status: Status): AlertColor => {
  if (status === 'blocked') return 'error';
  if (status === 'enabled') return 'success';

  return 'info';
};
